import api from "./apiClient";

/* ===================================================== */
/* 🔧 ERROR NORMALIZER                                   */
/* ===================================================== */

function normalizeError(err, fallbackMessage) {
  return new Error(
    err?.response?.data?.message ||
      err?.message ||
      fallbackMessage
  );
}

/* ===================================================== */
/* INVITE COMPANY MEMBER                                 */
/* POST /company/invite                                  */
/* ===================================================== */

export const inviteCompanyMember = async ({
  name,
  email,
  teamId,
}) => {
  if (!email?.trim()) {
    throw new Error("Invite email is required");
  }

  try {
    const { data } = await api.post("/company/invite", {
      name: name?.trim() || undefined,
      email: email.trim(),
      teamId: teamId || undefined,
    });

    return data;
  } catch (err) {
    throw normalizeError(err, "Failed to send invite");
  }
};

/* ===================================================== */
/* EXPORT                                                */
/* ===================================================== */

const inviteService = {
  inviteCompanyMember,
};

export default inviteService;